/* istanbul ignore file */
import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from 'react-oidc-context';
import './styles/styles.scss';
import './styles/_variables.scss';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import reportWebVitals from './reportWebVitals';
import './assets/icons/icons.scss';
import './assets/pictograms/pictograms.scss';
import './styles/font.css';
import { AppInsightsContextProvider } from './api/monitoring/AppInsightsContextProvider';
import oidcConfig from './auth/config';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            retry: 2,
            retryDelay: (attemptIndex) =>
                Math.min(1000 * 2 ** attemptIndex, 10000),
            staleTime: 60_000,
            refetchOnWindowFocus: false,
        },
        mutations: {
            retry: false,
        },
    },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <QueryClientProvider client={queryClient}>
            <AuthProvider {...oidcConfig}>
                <AppInsightsContextProvider>
                    <App />
                </AppInsightsContextProvider>
            </AuthProvider>
        </QueryClientProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
